var _circle, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup503(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.7878,
    cy: 30.2126,
    r: 29.7878,
    fill: "#FEDC74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.3122 44.0163C32.3122 45.5606 31.9982 46.9339 31.5138 47.9026C31.0145 48.9013 30.4172 49.3286 29.9061 49.3286C29.395 49.3286 28.7977 48.9013 28.2984 47.9026C27.814 46.9339 27.5 45.5606 27.5 44.0163C27.5 42.4721 27.814 41.0988 28.2984 40.1301C28.7977 39.1314 29.395 38.7041 29.9061 38.7041C30.4172 38.7041 31.0145 39.1314 31.5138 40.1301C31.9982 41.0988 32.3122 42.4721 32.3122 44.0163Z",
    fill: "white",
    stroke: "#B4643A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.2653,
    cy: 28.7595,
    rx: 7.26531,
    ry: 6.53878,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.7186,
    cy: 28.7596,
    rx: 2.90612,
    ry: 3.63265,
    fill: "#B4643A"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.5153,
    cy: 28.7595,
    rx: 7.26531,
    ry: 6.53878,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.0624,
    cy: 28.7596,
    rx: 2.90612,
    ry: 3.63265,
    fill: "#B4643A"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 38,
    rx: 4,
    ry: 2,
    fill: "#FF9C8E"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5,
    cy: 38,
    rx: 4.5,
    ry: 2,
    fill: "#FF9C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup503);
export default __webpack_public_path__ + "static/media/Group 503.7cbcc9a9dcd62c2ae2e23a43453c0ea3.svg";
export { ForwardRef as ReactComponent };